<template>
  <div class="header-menu">
    <div class="main">
      <nuxt-link to="/" class="home-link" ><img src="https://video.reta-inc.com/image/default/77E201027F50449CA38EF4BC0E7F8537-6-2.jpg" alt="DG.hire" class="img"/></nuxt-link>
      <ul class="menu">
        <template v-for="(menu, index) in menus" :key="index">
          <li
            class="menu__submenu"
            v-if="menu.children?.length"
            :class="{ active: route.fullPath.startsWith(`/${menu.name}`) }"
            @click="onPrimaryMenuActive(menu)"
            @mouseover="onPrimaryMenuActive(menu)"
            @mouseleave="onPrimaryMenuInactive"
          >
            <div class="menu__submenu-title">{{ menu.title }}</div>
            <i class="icon-arrow-down"></i>
            <component
              v-if="componentMap[menu.name]"
              v-show="showSubMenuName === menu.name"
              :is="componentMap[menu.name]"
              :menuList="menu.children"
              @onMenuClick="onMenuClick"
            />
            <img
              v-if="menu.title === '资源中心'"
              class="hot"
              src="https://video.reta-inc.com/image/default/3661309FF2B64A0B9E264E5F6E6A7785-6-2.png"
              alt="hot"
            />
          </li>
          <li class="menu__item" v-else :class="{ active: route.path.includes(menu.url!) }" @click="onMenuClick(menu)">
            {{ menu.title }}
          </li>
        </template>
      </ul>

      <a-button
        v-if="!mobile"
        type="outline"
        href="https://e.dghire.com/b/login"
        style="margin-left: auto"
        class="login"
      >
        登录
      </a-button>
      <div class="btn-group">
        <nuxt-link
          class="free-trial"
          :to="getLeadsLink({ from: '导航栏-免费试用', path: route.path, type: 'freeTrial' })"
          >免费试用</nuxt-link
        >
        <a-dropdown v-if="mobile" :popup-visible="isDropdownOpened">
          <a-button class="nav" @click="isDropdownOpened = !isDropdownOpened">
            <template #icon>
              <icon-menu style="stroke-width: 5; font-size: 14px" />
            </template>
            <template #default>导航</template>
          </a-button>
          <template #content>
            <ul class="inner_menu">
              <template v-for="(menu, index) in menus" :key="index">
                <li
                  class="menu__submenu"
                  v-if="menu.children?.length"
                  :class="{
                    active: route.fullPath.startsWith(`/${menu.name}`),
                  }"
                  @click="onPrimaryMenuActive(menu)"
                >
                  <div class="menu__submenu-title">{{ menu.title }}</div>
                  <i class="icon-arrow-down" :class="{ active: showSubMenuName === menu.name }"></i>
                  <ul class="menu__sub" v-show="showSubMenuName === menu.name">
                    <li
                      class="menu__submenu-item"
                      v-for="submenu in menu.children"
                      :key="submenu.name"
                      @click.stop="onMenuClick(submenu)"
                    >
                      {{ submenu.title }}
                    </li>
                  </ul>
                </li>
                <li class="menu__item" v-else @click.stop="onMenuClick(menu)">
                  {{ menu.title }}
                </li>
              </template>
            </ul>
          </template>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import ProductMenu from '@/components/ProductMenu.vue';
import SolutionMenu from '@/components/SolutionMenu.vue';
import InfoMenu from '@/components/InfoMenu.vue';
import ResourceMenu from '@/components/ResourceMenu.vue';
import AboutMenu from '@/components/AboutMenu.vue';
import CustomerCaseMenu from '@/components/CustomerCaseMenu.vue';
import menus, { IMenuItem } from '@/common/menu';
import { getLeadsLink, isMobile } from '@/common/utils';
import nuxtConfig from '~~/nuxt.config';

const mobile = ref(false);
const route = useRoute();

const componentMap: Record<string, any> = {
  product: ProductMenu,
  solution: SolutionMenu,
  info: InfoMenu,
  resource: ResourceMenu,
  about: AboutMenu,
  showcase: CustomerCaseMenu,
};

onMounted(() => {
  mobile.value = isMobile();
});

const showSubMenuName = ref('');
function onPrimaryMenuActive(menu: IMenuItem) {
  if (mobile.value && showSubMenuName.value) {
    onPrimaryMenuInactive();
    return;
  }
  showSubMenuName.value = menu.name;
}
function onPrimaryMenuInactive() {
  showSubMenuName.value = '';
}

const isDropdownOpened = ref(false);
async function onMenuClick(menu: IMenuItem) {
  useLogger().track('menu', {
    source: menu.title,
  });
  await navigateTo(menu.url!);
  isDropdownOpened.value = false;
}

function findNameByPath(path: string) {
  const flatMenus = menus.reduce((acc: IMenuItem[], item: IMenuItem) => {
    if (!item.children?.length) {
      acc.push(item);
    } else {
      acc = acc.concat(item.children);
    }
    return acc;
  }, [] as IMenuItem[]);
  const selectedMenu = flatMenus.find(menu => menu.url === path);
  if (selectedMenu) {
    return selectedMenu.name;
  }
  return '';
}

function onTryClick() {
  useLeadsInfo('导航栏-免费试用', 'freeTrial');
}
</script>
<style lang="less" scoped>
.header-menu {
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.06);
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (min-width: 800px) {
    .main {
      display: flex;
      align-items: center;
      width: 1280px;
      height: 70px;
      margin: 0 auto;
      min-width: 1280px;
      padding: 0 32px;

      a.home-link {
        flex-shrink: 0;
        margin-right: 70px;
        width: 132px;
        height: 70px;
        overflow: hidden;
        .img {
          width: 100%;
          margin-top: -5px;
        }
      }

      .btn-group {
        margin-left: 12px;

        .free-trial {
          display: block;
          width: 80px;
          height: 36px;
          background: #165dff;
          border-radius: 4px;
          font-weight: 500;
          font-size: 14px;
          line-height: 36px;
          color: #ffffff;
          text-align: center;
          text-decoration: none;
        }
      }

      .arco-btn {
        border-radius: 4px;

        & + .arco-btn {
          margin-left: 12px;
        }
      }
    }

    ul,
    li {
      list-style-type: none;
      margin-block-start: 0;
      margin-block-end: 0;
      margin-inline-start: 0;
      margin-inline-end: 0;
      padding-inline-start: 0;
    }

    .nav {
      display: none;
    }

    .menu {
      display: flex;
      font-size: 16px;
      line-height: 22px;
      color: #1d2129;

      &__submenu,
      &__item {
        padding: 0 10px;
        height: 42px;
        display: flex;
        align-items: center;
        cursor: pointer;

        &:not(:first-child) {
          margin-left: 16px;
        }

        &.active,
        &:hover {
          font-weight: 500;
          color: #165dff;
        }
      }

      &__submenu {
        position: relative;

        .icon-arrow-down {
          display: block;
          width: 12px;
          height: 12px;
          background: url('@/assets/icons/arrow-down.svg') no-repeat;
          background-size: contain;
          margin-left: 8px;
        }

        @keyframes hot-move {
          0% {
            transform: scale(0);
          }

          20% {
            transform: scale(1);
          }

          25%,
          35%,
          45% {
            transform: rotate(-5deg);
          }

          30%,
          40%,
          50% {
            transform: rotate(5deg);
          }
          55%,
          100% {
            transform: rotate(0deg);
          }
        }

        .hot {
          width: 16px;
          position: absolute;
          top: 4px;
          right: 15px;
          transform-origin: 0 100%;
          animation: hot-move 4s linear infinite both;
        }
      }

      /* &__sub {
        position: absolute;
        top: 42px;
        left: -12px;
        background: #ffffff;
        box-shadow: 0px 8px 32px rgba(193, 193, 193, 0.3);
        border-radius: 8px;
        padding: 12px;
        font-weight: 400;
        color: #1d2129;
        z-index: 99;
      }

      &__submenu-item {
        min-width: 120px;
        height: 40px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        white-space: nowrap;

        &:not(:first-child) {
          margin-top: 4px;
        }

        &.active,
        &:hover {
          background: #f5f8ff;
          border-radius: 4px;
          font-weight: 500;
        }
      } */
    }

    .login {
      height: 36px;
    }
  }

  @media screen and (max-width: 800px) {
    .main {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 70px;
      padding: 0 16px;

      a.home-link {
        flex-shrink: 0;
        margin-right: 70px;
        width: 132px;
        height: 70px;
        overflow: hidden;
        .img {
          width: 100%;
          margin-top: -5px;
        }
      }

      .arco-btn {
        border-radius: 4px;

        &:first-child {
          margin-right: 12px;
        }
      }

      .login {
        display: none;
      }

      .btn-group {
        display: flex;
        align-items: center;

        .free-trial {
          display: block;
          width: 80px;
          height: 32px;
          background: rgba(22, 93, 255, 0.1);
          border-radius: 4px;
          font-weight: 500;
          font-size: 14px;
          line-height: 32px;
          color: #165dff;
          text-align: center;
          text-decoration: none;
          margin-right: 12px;
        }

        :deep(.arco-dropdown-open) {
          background: #165dff;
          color: #fff;
        }
      }

      :deep(.arco-btn-size-medium:not(.arco-btn-only-icon) .arco-btn-icon) {
        margin-right: 4px;
      }

      .nav {
        font-weight: 500;
        font-size: 14px;
        line-height: 12px;
        color: #165dff;
        padding: 8px;
        border: 1px solid #165dff;
        background: #fff;
      }
    }

    .menu {
      display: none;
    }

    .menu_icon {
      margin-left: 16px;
    }
  }
}

@media screen and (min-width: 800px) {
  .header-menu {
    min-width: 1344px;
  }
}
</style>
<style lang="less">
.arco-trigger-popup .arco-trigger-content {
  .arco-dropdown-list-wrapper {
    max-height: unset;
  }

  .inner_menu {
    // display: flex;
    box-sizing: border-box;
    padding: 0 32px;
    width: 100vw;
    font-size: 16px;
    line-height: 22px;
    color: #1d2129;

    ul,
    li {
      list-style-type: none;
      margin-block-start: 0;
      margin-block-end: 0;
      margin-inline-start: 0;
      margin-inline-end: 0;
      padding-inline-start: 0;
    }

    .menu__submenu {
      position: relative;

      .icon-arrow-down {
        position: absolute;
        right: 0;
        top: 17px;
        display: block;
        width: 12px;
        height: 12px;
        background: url('@/assets/icons/arrow-down.svg') no-repeat;
        background-size: contain;
        margin-left: 8px;
      }

      .active {
        transform: rotate(180deg);
      }

      .menu__sub {
        padding-top: 15px;

        .menu__submenu-item {
          padding: 15px 0;
        }
      }
    }

    .menu__submenu,
    .menu__item {
      padding: 12px 0;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #1d2129;
    }

    .menu__submenu:not(:last-child),
    .menu__item:not(:last-child) {
      border-bottom: 1px solid #f2f3f5;
    }

    .menu__submenu-item {
      font-size: 14px;
      line-height: 18px;
      color: #4e5969;
    }
  }
}
</style>
